/* unplugin-vue-components disabled */import { render } from "./DeviceSystem.vue?vue&type=template&id=425bbcf0&scoped=true"
import script from "./DeviceSystem.vue?vue&type=script&lang=js"
export * from "./DeviceSystem.vue?vue&type=script&lang=js"

import "./DeviceSystem.vue?vue&type=style&index=0&id=425bbcf0&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425bbcf0"]])

export default __exports__